<div class="relative">

  <button (click)="toggleDropdown()" class="flex items-center text-gray-700 dropdown-toggle dark:text-gray-400 mr-3 gap-3">
    <lib-icon name="user-avatar"/>      
    <span class="font-title text-theme-sm font-bold ">{{ firstName }}</span>
    <lib-icon name="chevron-down" class="arrow" [class.open]="isOpen"></lib-icon>
  </button>

  <lib-dropdown [isOpen]="isOpen" (close)="closeDropdown()"
    className="absolute right-0 mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark">
    <div class="mb-3">
      <span class="block font-medium text-gray-700 text-theme-sm font-title dark:text-gray-400">
        {{user()?.name}}
      </span>
      <span class="mt-0.5 block text-theme-xs text-gray-500 font-title dark:text-gray-400">
        {{user()?.email}}
      </span>
      @if (user()?.isEmailValid !== null && !user()?.isEmailValid) {
        <span class="mt-0.5 block text-theme-xs text-warning-500 font-title dark:text-warning-400">
          Correo no verificado
        </span>
      }
    </div>
    @if(showButtonBack){
      <!-- <div class="border-b border-gray-200 dark:border-gray-800 mb-3 mt-3"></div> -->
      <a routerLink="/"
        class="font-title flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
        <lib-icon name="community-switch" class="mr-3 arrow"/>
        Cambiar de comunidad
      </a>
    }
    <div class="border-b border-gray-200 dark:border-gray-800 mb-3 mt-3"></div>
      <button
        (click)="signOut(); toggleDropdown(); $event.stopPropagation()"
        class="font-title flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
        <lib-icon name="exit" class="mr-3 arrow"/>
        Cerrar sesión
      </button>
    @if (versionInfo()) {
      <div class="px-3 py-2 text-center border-t border-gray-200 dark:border-gray-800 mt-3">
        <span class="text-xs text-gray-500 dark:text-gray-400">
          Net3 {{ versionInfo().platform === 'web' ? 'Web' : 'App' }} v{{ versionInfo().appVersion }}
        </span>
      </div>
    }
  </lib-dropdown>
</div>